import { useMutation, useQueryClient } from "react-query";
import { createSmsTemplate, updateSmsTemplate, SMS_QUERY_KEYS } from "@/services/sms";

/** Variables for the save mutation; presence of `id` switches create/update. */

/** Mutation hook that creates or updates an SMS template and refreshes the list. */
export function useSaveSmsTemplate(workspaceId) {
  var queryClient = useQueryClient();
  return useMutation(function (_ref) {
    var id = _ref.id,
      payload = _ref.payload;
    return id ? updateSmsTemplate(id, payload) : createSmsTemplate(payload);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(SMS_QUERY_KEYS.templates(workspaceId));
    }
  });
}